module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "fm"
  }, [_vm._v("Aguacero")]), _vm._v(" "), _c('p', {
    staticClass: "fm1"
  }, [_vm._v("beautiful musician")]), _vm._v(" "), _c('p', {
    staticClass: "fm1"
  }, [_vm._v("unclothed at the foot of a tree")]), _vm._v(" "), _c('p', {
    staticClass: "fm1"
  }, [_vm._v("amidst the lost harmonies")]), _vm._v(" "), _c('p', {
    staticClass: "fm1"
  }, [_vm._v("close to our defeated memories")]), _vm._v(" "), _c('p', {
    staticClass: "fm1"
  }, [_vm._v("amidst our hands of defeat")]), _vm._v(" "), _c('p', {
    staticClass: "fm1"
  }, [_vm._v("and a people of alien strength")]), _vm._v(" "), _c('p', {
    staticClass: "fm1"
  }, [_vm._v("we let our eyes hang low")]), _vm._v(" "), _c('p', {
    staticClass: "fm1"
  }, [_vm._v("and untying")]), _vm._v(" "), _c('p', {
    staticClass: "fm1"
  }, [_vm._v("the tether of a natal anguish")]), _vm._v(" "), _c('p', {
    staticClass: "fm1"
  }, [_vm._v("we sobbed")]), _vm._v(" "), _c('p', {
    staticClass: "fm2"
  }, [_vm._v("—Aimé Cesairé, “Blues of the Rain”")]), _vm._v(" "), _c('p', {
    staticClass: "fm3"
  }, [_vm._v("trans. Clayton Eshleman and Annette Smith")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-19aede34","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/part0005.vue
// module id = 72
// module chunks = 0